import { BANKS } from '../lib/banks';
// ── Question Bank ──────────────────────────────────────────────────
// The interactive bank (seed + generated, see questionBankSeed.ts) is served as /banks/interactive.json behind the
// content gate and filled in place by loadBanks() after sign-in; it is never compiled into the app.

export type QuestionBankEntry = {
  id: string;
  examProgram: 'naplan' | 'selective_nsw' | 'oc' | 'acer' | 'icas' | 'hsc' | 'vce';
  yearId: 'y3' | 'y4' | 'y5' | 'y6' | 'y7' | 'y8' | 'y9' | 'y10' | 'y11' | 'y12';
  subject: 'reading' | 'numeracy' | 'writing' | 'language' | 'thinking' | 'science' | 'humanities' | 'english' | 'maths'
    | 'english_advanced' | 'mathematics_advanced' | 'physics' | 'chemistry' | 'biology'
    | 'modern_history' | 'legal_studies' | 'economics' | 'mathematical_methods'
    | 'further_mathematics' | 'australian_history' | 'abstract_reasoning';
  primitiveType: 'DragDrop' | 'InlineCloze' | 'HotSpot' | 'HotText2' | 'ExtractMatching' | 'GapMatch' | 'ImageMCQ' | 'ExamMode';
  config: any; // primitive-specific config object
  difficulty?: 'easy' | 'medium' | 'hard';
  source?: string;
};


export const QUESTION_BANK: QuestionBankEntry[] = BANKS.interactive as QuestionBankEntry[];
